import { render, staticRenderFns } from "./psyprose.vue?vue&type=template&id=9daa0478&scoped=true&"
import script from "./psyprose.vue?vue&type=script&lang=js&"
export * from "./psyprose.vue?vue&type=script&lang=js&"
import style0 from "./psyprose.vue?vue&type=style&index=0&id=9daa0478&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9daa0478",
  null
  
)

export default component.exports